import { createTheme, styled, withStyles } from '@material-ui/core/styles';
import Styled from "styled-components";
import {
    Button,
    MenuItem,
    Grid,
    TableCell,
    StepLabel,
    TablePagination,
    TextField,
    Dialog,
    TableContainer,
    Tab,
    Tooltip
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';


const muiTheme = createTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                backgroundColor: '#0C4D82',
                fontFamily: 'Open Sans',
                padding: '0.5vw 1.5vw',
                fontSize: '1vw',
                borderRadius: '0.5vw',
                minWidth: '0px !important'
            }
        },
        MuiStepIcon: {
            root: {
                color: '#CFD8E0',
                '&$active': {
                    color: '#0C4D82',
                },
                '&$completed': {
                    color: '#0C4D82',
                },
            },
        },
        MuiStepLabel: {
            label: {
                fontFamily: 'Open Sans',
                fontSize: '1vw'

            },
            active: {
                fontFamily: 'Open Sans',
                fontSize: '1vw'
            }
        },
        MuiStepContent: {
            root: {
                color: 'yellow',
            },
        },

        MuiFormControlLabel: {
            root: {
                color: '#0C4D82',
                fontFamily: 'Open Sans'
            },
        },

        MuiButton: {
            root: {

                fontFamily: 'Open Sans',
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '0.5vw',
                fontSize: '0.875vw',
                lineHeight: '1.75',
                whiteSpace: 'nowrap',
            },


        },
        MuiDialogContentText: {
            root: {
                fontFamily: 'Open Sans',
                color: '#0C4D82'
            },
        },

        MuiIconButton: {
            root: {
                fontSize: '1vw',
                '&$active': {
                    backgroundColor: 'none',

                },
                '&:hover': {
                    color: 'white',
                    outline: 'none',
                },
                label: {
                    fontSize: '1vw',

                },
                transition: {

                }

            },



        },

        MuiOutlinedInput: {
            input: {
                padding: '8px  20px',
            }
        },

        MuiSvgIcon: {
            root: {
                width: '1.5vw',
                height: '1.5vw',
            }
        },


        MuiDialogTitle: {
            root: {
                fontFamily: 'Open Sans',
            },
        },

        MuiPaper: {
            rounded: {
                borderRadius: '0.5vw'
            },
        },

        MuiTypography: {
            root: {
                color: '#0C4D82',
                fontFamily: 'Open Sans',
                fontWeight: 'bold',
                lineHeight: 2.5,
                fontSize: '1vw'


            },
            colorPrimary: {
                color: '#0C4D82 !important',
            },

            colorTextSecondary: {
                color: '#0C4D82',
                fontFamily: 'Open Sans',
            }
        },
        MuiMenuItem: {
            root: {
                fontFamily: 'Open Sans',
                color: '#0C4D82',
                fontSize: '1vw',
                /*
                '@media (min-width: 1200px)': {
                    fontSize: '1.8vw',
                }
                */
            }
        },
        MuiRadio:{
            colorSecondary:{
                color: '#0C4D82'
            }
        },
        MuiStepper:{
            root:{
                padding: '1vw 0vw 1vw 0vw' 
            }
        },
        MuiFormLabel:{
            root:{
                focused:{
                    color: '#0C4D82'
                }
            }
        },
    }
});


const ValidationTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#0C4D82',
                borderWidth: '0.1vw',
                borderRadius: '0.5vw',
            },
            '&:hover fieldset': {
                borderColor: '#0C4D82',
                borderWidth: '0.1vw',
                borderRadius: '0.5vw',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#0C4D82',
                borderWidth: '0.1vw',
                borderRadius: '0.5vw',
            },
        },
    },
})(TextField);

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 800,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
});

const ServiceDialog = withStyles({
    root:{
       '& .MuiDialog-paperWidthSm':{
            maxWidth: '90vw',
       }
    }
})(Dialog);


const ParamsTableContainer = styled(TableContainer) ({
    width: '100% !important'    
})

const GetUrlText = styled(TextField)({
    width: '40vw',
})

const NameTextField = withStyles({
    root:{
        '& .MuiInputBase-input':{
            backgroundColor: '#CFD8E0',
            color: '#0C4D82',
        },
        '& .MuiInputBase-multiline':{
            padding: '0vw',
        }
    }
})(TextField);


const TabParams = withStyles({
    root:{
        '& .MuiTab-wrapper': {
            color: '#0C4D82'
        }
    }
})(Tab);

/*  Buttons */

const MyIconButton = styled(Button)({

    fontSize: '1vw',
    fontWeight: 'normal',
    borderStyle: 'solid',
    borderWidth: '0.02vw',
    borderColor: '#0C4D82',
    padding: '0px 10px',
    lineHeight: 2.3
})

const ConfirmButton = styled(Button)({
    backgroundColor: '#0C4D82',
    color: 'white',
    outline:'none',
    '&:hover': {
        backgroundColor: '#0C4D82',
        color: 'white',
        outline:'none',
    }

})

const CancelButton = styled(Button)({
    backgroundColor: 'white',
    color: '#0C4D82',
    borderStyle: 'solid',
    borderWidth: '0.02vw',
    borderColor: '#0C4D82',
    "&:hover": {
        backgroundColor: '#CFD8E0',
        color: '#0C4D82',
        borderStyle: 'solid',
        borderWidth: '0.02vw',
        borderColor: '#0C4D82',
    }
})

const DisabledButton = styled(Button)({
    backgroundColor: 'white',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#CFD8E0',
    outline: 'none',
    color: '#CFD8E0',
    fontWeight: 'bold',
    textAlign: 'center',
    "&:hover": {
        backgroundColor: 'white',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: '#CFD8E0',
        outline: 'none',
        color: '#CFD8E0',
        fontWeight: 'bold',
        textAlign: 'center',
    }
})


const NextButton = styled(Button)({

    borderStyle: 'solid',
    borderColor: '#CFD8E0',
    color: '#0C4D82',
    backgroundColor: '#CFD8E0',
    fonteight: 'bold',
    outline: 'none',
    textAlign: 'center',
    "&:hover": {

        borderStyle: 'solid',
        borderColor: '#CFD8E0',
        color: '#0C4D82',
        backgroundColor: '#CFD8E0',
        fonteight: 'bold',
        outline: 'none',
        textAlign: 'center',
    }
})

const MyBlueButton = styled(Button)({
    backgroundColor: '#0C4D82',
    color: 'white',
    "&:hover": {
        backgroundColor: '#0C4D82',
        color: 'white',
    }
})

const NewServiceButton = styled(Button)({
    color: '#0C4D82',
    fontFamily: 'Open Sans',
    fontSize: '1vw',
    lineHeight: 1.5,
    fontWeight: 'bold',
    backgroundColor: '#CFD8E0',
    "&:hover":{
        backgroundColor: '#CFD8E0',
        color: '#0C4D82'
    }
})

const MyStepLabel = styled(StepLabel)({
        color: 'yellow',
})

const MyWhiteButton = styled(Button)({

        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontSize: '1vw',
        textTransform: 'uppercase',
        fontWeight: 'bold'
        /*
        '@media (max-width: 900px)': {
            display : 'none',
        }
        */
})



const MyMenuItem = styled(MenuItem)({
    color: '#0C4D82',
    fontFamily: 'Open Sans',
    fontSize: '1vw',
    /*
    '@media (min-width: 1200px)': {
        fontSize: '1.8vw',
    }
    */
})


const MyAppBarVertIcon = styled(MoreVertIcon)({
    color: '#FFFFFF',

    '@media (min-width: 901px)': {
        display:'none',
    }

})

const MyHidden = styled(Grid)({
    '@media (max-width: 700px)': {
        display: 'none',
    }
})

const MyTableCell = styled(TableCell)({
    fontSize: '1vw',

    /*
    '@media (max-width: 700px)': {
        fontSize: '5vw',
    }
    */
})

const MyTableCell1 = styled(TableCell)({
    borderRightColor: '#DDE3E9',
    borderRightStyle: 'solid',
    borderBottomColor: '#DDE3E9',
    borderBottomStyle: 'solid',
    borderRightWidth: 2,
    borderBottomWidth: 2,
    fontSize: '1vw',
    /*
    '@media (max-width: 700px)': {
        fontSize: '5vw',
    }
    */

})

const MyTableCell2 = styled(TableCell)({
    borderLeftStyle: 'solid',
    borderLeftWidth: 2,
    fontSize: '1vw',
    /*
    '@media (max-width: 700px)': {
        fontSize: '5vw',
    }
    */
})

const CustomTooltip = withStyles(() => ({
    tooltip: {
      fontSize: '1rem',
    },
  }))(Tooltip);

const MyTablePagination = styled(TablePagination)({

})

const Wrapper = Styled.section`
.container {
    display: flex;
    justify-content: center;
    > div:nth-child(1)

{
    width: 25%;
    height: 45%;
    font-size: 2rem;
    margin-bottom: 20px;


.login-container {
    background-color: #E83C52;
    width: 100%;
    min-width: 10vw;
    border-radius: 8px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    > .login-link

{
    text-decoration: none;
    color: #fff;
    font-family: Open Sans;
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 3vw;
    > span:nth-child(2)

{
    margin-left: 5px;
}

}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.5vw;
    min-width: 20vw;
}

.loader {

    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 1vw;
    height: 1vw;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

}
}
}
`;


export {
    muiTheme,
    Wrapper,
    MyWhiteButton,
    MyAppBarVertIcon,
    MyMenuItem,
    MyHidden,
    theme,
    MyTableCell1,
    MyTableCell2,
    MyTableCell,
    MyStepLabel,
    MyTablePagination,
    MyIconButton,
    ConfirmButton,
    CancelButton,
    MyBlueButton,
    DisabledButton,
    NextButton,
    ValidationTextField,
    GetUrlText,
    ServiceDialog,
    ParamsTableContainer,
    NewServiceButton,
    NameTextField,
    TabParams,
    CustomTooltip
};
